export const defaultSEODescription =
  'Whether you are lucky enough to call one of our listed towns home, or you’re just visiting, we hope you’ll find everything you need here to make the most of it. ';
export const defaultSEOTitle = 'Xplore: Everything is local.';
